import { isPlatformBrowser } from '@angular/common';
import {
    AfterViewInit,
    Directive,
    ElementRef,
    EventEmitter,
    Inject,
    Input,
    OnDestroy,
    Output,
    PLATFORM_ID,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

/**
 * @description
 * Emits the `appear` event when the element comes into view in the viewport.
 *
 */
@Directive({
    selector: '[kbOnVisible]',
    standalone: true,
})
export class OnVisibleDirective implements AfterViewInit, OnDestroy {
    @Input() rootMargin = '0px';
    @Output() visibilityChange = new EventEmitter<boolean>();
    private observer: IntersectionObserver;
    private subscription: Subscription;
    private lastIsIntersectingState = false;

    constructor(
        private element: ElementRef,
        private router: Router,
        @Inject(PLATFORM_ID) private platformId: any,
    ) {}

    ngAfterViewInit() {
        if (isPlatformBrowser(this.platformId)) {
            const options = {
                root: null,
                rootMargin: this.rootMargin,
                threshold: 0,
            };

            this.observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    this.lastIsIntersectingState = entry.isIntersecting;
                    this.visibilityChange.next(entry.isIntersecting);
                });
            }, options);
            this.observer.takeRecords();
            this.observer.observe(this.element.nativeElement);

            this.subscription = this.router.events
                .pipe(filter((event) => event instanceof NavigationEnd))
                .subscribe(() => {
                    this.visibilityChange.next(this.lastIsIntersectingState);
                });
        }
    }

    ngOnDestroy() {
        this.observer?.disconnect();
        this.subscription?.unsubscribe();
    }
}
